import _ from 'lodash';

const formatErrors = errors => {
  if (typeof errors === 'string') {
    return [{ key: 'error', error: errors }];
  }
  return _.flatten(
    _.map(_.pickBy(errors, v => v.length), (errorList, field) => errorList.map(err => ({
      error: `${_.capitalize(field)}: ${err}`,
      key: `error-${field}-${err}`,
    }))),
  );
};

export default formatErrors;
